import React from "react";

export const SaasContext = React.createContext(null);
